import { HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FeedbackService } from './feedback.service';

@Component({
  selector: 'app-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.scss'],
})

export class FeedbackDialogComponent implements OnInit {

  maxFileSize = 1024 * 1024 * 10; // 10MB
  maxFiles = 3;

  feedbackType: Number = null;
  comments: String = null;
  files: Array<File> = [];
  filesContents: { name: String, srcURL: SafeResourceUrl }[] = [];
  feedbackUploadProgress: any = false;
  inputFilesLoading: Boolean = false;
  error: String = null;
  feedbackID: Number = null;

  constructor(
    public feedbackService: FeedbackService,
    public sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<FeedbackDialogComponent>
  ) { }

  ngOnInit() { }

  onFileUpload(e: { target: HTMLInputElement }): void {
    const { target } = e;
    // files will have a type of FileList object
    const { files } = target;

    this.error = null;

    const filesArray = Array.from(files);

    if (filesArray.length > 0) {
      if (filesArray.length > this.maxFiles) {
        this.error = `Max ${this.maxFiles} images are allowed`;
      } else {
        try {
          this.inputFilesLoading = true;

          this.filesContents = filesArray.map((file: File) => {
            if (file.size > this.maxFileSize) {
              throw new Error(`"${file.name}" size is larger than max size of 10MB`);
            }

            // Using an object URL is much faster and less heavy on processing than using a base64 string
            return {
              name: file.name,
              // If you don't bypass URL security URL, it will throw an error. This only happens in Angular
              srcURL: this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file))
            };
          });

          this.files = filesArray;
        } catch (err) {
          this.error = err;
          this.filesContents = [];
          this.files = [];
        } finally {
          this.inputFilesLoading = false;
        }
      }
    }
  }

  onClearImages(): void {
    this.files = [];
    this.filesContents = [];
  }

  onCancel(): void {
    if (!this.feedbackID) {
      this.error = null;
      this.onClearImages();
      this.saveCancelledResponse();
    }
    this.dialogRef.close();
  }

  onSave(): void {
    this.error = null;
    this.feedbackUploadProgress = true;

    // If there feedback ID is recorded and files API had an error
    if (this.feedbackID) {
      this.uploadFiles(this.feedbackID);
    } else {
      this.saveResponse();
    }
  }

  saveCancelledResponse(): void {
    this.feedbackService.reportCancelledFeedback().subscribe(() => { }, err => console.error(err));
  }

  saveResponse(): void {
    this.feedbackService.reportFeedback(this.feedbackType, this.comments).subscribe(id => {
      // If there are files then we need to call the files feedback API
      this.feedbackID = id;
      if (this.files.length > 0) {
        this.uploadFiles(id);
      } else {
        this.feedbackUploadProgress = false;
        this.dialogRef.close();
      }
    }, err => {
      console.error(err);
      this.feedbackUploadProgress = false;
      this.error = err;
    });
  }

  uploadFiles(id: Number): void {
    this.feedbackService.reportFeedbackImages(id, this.files).subscribe(response => {
      if (response) {
        if (response.type === HttpEventType.Response) {
          this.feedbackUploadProgress = false;
          this.dialogRef.close();
        } else if (response.type === HttpEventType.UploadProgress) {
          // Calculates upload progress
          this.feedbackUploadProgress = Math.round(response.loaded * 100 / response.total);
        }
      }
    }, err => {
      this.feedbackUploadProgress = false;
      this.error = err;
    });
  }

}
